<template>
	<v-btn v-bind="$attrs" v-on="$listeners" class="round-button round-svg-button">
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'RoundButton',
	props: {},
};
</script>

<style scoped lang="scss">
.round-button {
	padding: 0 !important;

	&::v-deep {
		&.v-btn:not(.v-btn--rounded):not(.v-btn--tile) {
			border-radius: 50% !important;
		}
	}

	&.round-svg-button {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 20px;
		width: 20px;
		border-radius: 50%;
		background-color: #f0f1f3;

		&:hover {
			cursor: pointer;
			filter: brightness(85%);
			transition: 0.2s;
		}
		&:hover {
			transition: 0.3s;
		}
	}
}
</style>
